module.exports = __webpack_public_path__ + "img/hr-tree-09-e-trunk.3829f061.png";